module.exports = __webpack_public_path__ + "static/blackchancery-753833d2833e9f73b56cffae357cf95f.ttf";